

































































































































































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import moment from 'moment';
import 'moment/locale/ru';

import { STORE_KEY, store } from './_store';
import WAEditForm from './WAEditForm/WAEditForm.vue'
import { add } from 'numeral';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',
      'filter', 'employees',
      'planItems', 'factItems', 'texts'
    ]),
    // ...mapGetters(STORE_KEY, [
    //   'currentEmployeeFilterValue'
    // ]),
    ...mapState('ubic', [
      'actor', 'token'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'changeFilterValue', 'markItemForEdit', 'changeItemValue'
    ])
  },
  components: {
    TitleBar,
    WAEditForm
  }
})
export default class WorkPlanBoard extends Vue {

  actor!: any;
  token!: any;
  filter!: any;
  employees!: any[];
  planItems!: any[];
  texts!: any;
  isRange: boolean = false;

  get titleStack () {
    return [
      'План / Факт'
    ]
  }
  moment = moment

  isFriday() {
    // @ts-ignore
    const date = (this.filter.targetDate instanceof Array) ? this.filter.targetDate[0] : this.filter.targetDate;
    return [5, 6, 7].includes(moment(date).isoWeekday())
  }

  isFridayOnly() {
    // @ts-ignore
    const date = this.filter.targetDate instanceof Array ? this.filter.targetDate[0] : this.filter.targetDate;
    return [5].includes(moment(date).isoWeekday())
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  changeFilterValue(params: any) {
    const query: any = {};
    query[params.field] = params.newValue
    this.$router.replace({
      query: {
        ...query,
        ...this.$route.query
      }
    });
    this.$store.dispatch(`${STORE_KEY}/changeFilterValue`, params);
  }

  // selected(option: any) {
  //   console.log(this.filter.employeeID, option.id);
  //   return this.filter.employeeID = option.id
  // }
  get canEdit() {
    // @ts-ignore
    const date = this.filter.targetDate instanceof Array ? this.filter.targetDate[0] : this.filter.targetDate;
    if (this.filter.employeeId && this.filter.employeeId === this.actor.document.id && !this.afterWorkDay) {
      if (moment(date).isSame(moment(), 'day')) {
        if (moment().isSameOrBefore(moment().set('hour', 22).set('minutes', 0), 'minutes')) {
          return true;
        }
      }
    }

    return true;
  }

  get afterWorkDay() {
    return moment().hour() > 18
  }

  waTemplateWithLK = 'Добрый день! Воспользуйтесь личным кабинетом, чтобы сделать заявку с доставкой{addr}';
  waTemplateWithoutLK = 'Здравствуйте, потребуется ли поставка{addr}';

  opendeSources: any[] = [];

  public mounted() {
    this.handleParamsChange();
  }

  formatMessage(item: any) {
    let message = (item.source_attributes.have_lk) ? this.waTemplateWithLK : this.waTemplateWithoutLK;
    // @ts-ignore
    const date = this.filter.targetDate instanceof Array ? this.filter.targetDate[0] : this.filter.targetDate;
    const targetDate = moment(date);
    const nextDay = moment(targetDate).add(1, 'day');
    console.log(message, item.source_attributes);

    if (targetDate.day() < 5) {
      message = `${message} на завтра, ${nextDay.format('dd')}, ${nextDay.format('DD.MM.YYYY')}`;
    } else {
      const nextWeek = moment(targetDate).add(1, 'week').startOf('week');
      console.log('nextWeek', nextDay, nextWeek);
      const days = []
      if (item.source_attributes.with_saturday || !item.source_attributes.is_strict) {
        days.push(`в сб, ${nextDay.format('DD.MM.YYYY')}`);
      }
      if (item.source_attributes.with_monday || !item.source_attributes.is_strict) {
        days.push(`в пн, ${nextWeek.format('DD.MM.YYYY')}`);
      }
      message = `${message} ${days.join(' и/или ')}`

    }
    message = message.replace('{addr}', (item.source_attributes.with_address? ' ' + item.source_attributes.delivery_point_address : '')) + '?';

    return message
  }

  onWaOpen(item: any, withAddress: boolean, message?: string) {
    const msg = message ? message : this.formatMessage(item);
    this.saveWASendLog(item)
    this.onWASend(
      msg,
      this.cleanPhone(item.source_attributes.person_whatsapp)
    )
    this.$buefy.snackbar.open(`Сообщение отправлено`);
  }

  cleanPhone(phoneNumber: string) {
    let phone = phoneNumber;
    if (!phoneNumber.includes('@')) {
      phone = phone.replace(/[^0-9-]+/g, '')
      if (phone.length  == 11) {
        phone = phone.slice(1);
      }
      if (phone.length  == 10) {
        phone = '7' + phone
      }
    }
    return phone
  }

  openNewDealDialog(item: any) {
    this.$router.push({
      name: 'deal-details',
      params: {
        id: 'new'
      },
      query: {
        client_id: item.source_related_to_id,
        manager_id: item.reponsible_id, 
        delivery_point_id: item.source_attributes.delivery_point_id,
        status_id: 'd:statuses:13',
        expected_delivery_date: moment(item.source_date).format('YYYY-MM-DD'),
        name: item.source_attributes.client_name
      }
    });
  }

  rejectDeal(item: any) {
    this.$store.dispatch(`${STORE_KEY}/rejectDeal`, {
      client_deals_schedule_state_record_id: item.source_attributes.client_deals_schedule_state_record_id,
      date: moment(item.source_date).format('YYYY-MM-DD'),
      created_by_id: this.actor.document.id
    }).then(() => {
      this.$buefy.snackbar.open(`Данные успешно сохранены`);
    }).catch(() => {
      this.$buefy.snackbar.open({
        type: 'is-warning',
        message: `При сохранении возникли проблемы. Попробуйте позже.`
      })
    });
  }

  onWAEditAll() {
    this.$buefy.modal.open({
      component: WAEditForm,
      props: {
        isNew: !this.texts['0'] || !this.texts['0'].id,
        documentPreview: this.texts['0'],
        initParams: {}
      },
      events: {
        'send': (text: string) => {
          this.onWASendAll(text)
        },
      },
      hasModalCard: false,
      fullScreen: false,
      customClass: 'document-form1 short-form',
      parent: this
    })
  }

  onWAEdit(item: any) {
    const week_days: any[] = [];
    let add_days: string = ''
    if ((item.source_attributes.with_saturday || item.source_attributes.with_monday) && this.isFridayOnly()) {
      add_days = ', нужна ли доставка на '
      if (item.source_attributes.with_saturday) {
        week_days.push('субботу')
      }
      if (item.source_attributes.with_monday) {
        week_days.push('понедельник')
      }
      add_days = add_days + (week_days.join(' или '))
    }
    this.$buefy.modal.open({
      component: WAEditForm,
      props: {
        isNew: !this.texts[item.source_related_to_id] || !this.texts[item.source_related_to_id].id,
        documentPreview: this.texts[item.source_related_to_id],
        initParams: {
          client_id: item.source_related_to_id,
          text: this.formatMessage(item)
        }
      },
      events: {
        'send': (text: string) => {
          this.onWaOpen(item, item.source_attributes.with_address, text)
        },
      },
      hasModalCard: false,
      fullScreen: false,
      customClass: 'document-form1 1short-form',
      parent: this
    })
  }

  onWASendAll(message: string) {
    this.$buefy.dialog.confirm({
      message: `Выполнить рассылку по всем клиентам?`,
      confirmText: 'Выполнить',
      cancelText: 'Отменить',
      trapFocus: true,
      onConfirm: (value: any) => {
        const prev: any[] = [];
        this.planItems.map((item: any) => {
          if (item.source_attributes.person_whatsapp && !prev.includes(item.source_attributes.person_whatsapp)) {
            const msg = this.formatMessage(item)
            this.saveWASendLog(item)
            this.onWASend(
              msg,
              this.cleanPhone(item.source_attributes.person_whatsapp)
            )
            prev.push(item.source_attributes.person_whatsapp)
          }
        })
        this.$buefy.snackbar.open(`Все сообщения отправлены`);
      }
    })

  }

  saveWASendLog(item: any) {
    this.$store.dispatch(`${STORE_KEY}/saveWASendLog`, item).then(() => {
      this.$store.dispatch(`${STORE_KEY}/loadData`);
    })
  }

  onWASend(message: string, to: string) {
    //console.log(message)
    // to = '79135129601';
    const url = process.env.VUE_APP_UBIC_SERVER_ADDRESS + '/api/v1/wa/send/?';
    const xmlhttp = new XMLHttpRequest();   // new HttpRequest instance
    xmlhttp.open("POST", url);
    xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xmlhttp.setRequestHeader("Authorization", this.token);
    xmlhttp.send(JSON.stringify({ "body": message, "to": to }));
  }

  saveItem(item: any) {
    this.$store.dispatch(`${STORE_KEY}/saveItem`, item)
    .then(() => {
      this.$buefy.snackbar.open(`Данные успешно сохранены`);
      this.handleParamsChange();
    }).catch(() => {
      this.$buefy.snackbar.open({
        type: 'is-warning',
        message: `При сохранении возникли проблемы. Попробуйте позже.`
      })
    });
  }

  openDeal(dealId: string) {
    this.$router.push({
      name: 'deal-details',
      params: {
        id: dealId
      }
    });
  }

  // ---------------------------------------------------------------------------

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      employeeId: this.$route.query.employee_id || this.actor.document.id,
    });
  }

  // public refreshData($event: any) {
  //   this.$store.dispatch(`${STORE_KEY}/loadData`)
  //     .finally(() => {
  //       $event.detail.complete();
  //     });
  // }
}
